import React from 'react';

export default function OurSkills() {
    return (
        <div className="our-skill-area fix hidden-sm">
            <div className="test-overly" />
            <div className="skill-bg area-padding-2">
                <div className="container">
                    {/* section-heading end */}
                    <div className="row">
                        {/* single-skill start */}
                        <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                            <div className="single-skill">
                                <div className="progress-circular">
                                    <h3 className="progress-h4">mais de 50.000 clientes atendidos</h3>
                                </div>
                            </div>
                        </div>
                        {/* single-skill end */}
                    </div>
                </div>
            </div>
        </div>
    )
}